import { RangePreset } from "@shared/common/RangePicker/types";
import dayjs, { Dayjs } from "dayjs";
import { DefaultTimeFrame } from "@shared/types";

const adjustPreset = (date: Dayjs) => {
  return date.add(1, "days").startOf("day");
};

export const getRangePresets = (minValue?: Dayjs) => {
  const rangePresets: RangePreset[] = [
    {
      label: DefaultTimeFrame.TODAY,
      value: [dayjs().startOf("day"), dayjs().endOf("day")],
    },
    {
      label: DefaultTimeFrame.LAST_7_DAYS,
      value: [adjustPreset(dayjs().subtract(7, "days")), dayjs().endOf("day")],
    },
    {
      label: DefaultTimeFrame.LAST_30_DAYS,
      value: [adjustPreset(dayjs().subtract(30, "days")), dayjs().endOf("day")],
    },
    {
      label: DefaultTimeFrame.THIS_MONTH,
      value: [dayjs().startOf("month"), dayjs().endOf("day")],
    },
    {
      label: DefaultTimeFrame.LAST_QUARTER,
      value: [
        adjustPreset(dayjs().subtract(3, "months")),
        dayjs().endOf("day"),
      ],
    },
    {
      label: DefaultTimeFrame.LAST_6_MONTHS,
      value: [
        adjustPreset(dayjs().subtract(6, "months")),
        dayjs().endOf("day"),
      ],
    },
    {
      label: DefaultTimeFrame.LAST_YEAR,
      value: [adjustPreset(dayjs().subtract(1, "year")), dayjs().endOf("day")],
    },
  ];
  if (!minValue) return rangePresets;
  return rangePresets?.filter((preset) => preset.value[0] >= minValue);
};
